import styled from '@emotion/styled';
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Modal,
  ModalDialog,
} from '@mui/joy';

export const CustomModalContainer = styled(Modal)`
  backdrop-filter: blur(3px);
  background-color: rgba(17, 24, 39, 0.1);
`;

export const CustomModalDialog = styled(ModalDialog)`
  border-radius: 16px;
  gap: ${({theme}) => theme.gap.desktop.xl};
  padding: ${({theme}) => theme.padding.desktop.lg};

  // For bigger screens, the modal should take up 600px
  @media screen and (min-width: ${({theme}) => theme.screenBreakpoint.md.px}) {
    min-width: 600px;
    max-width: 600px;
  }

  // For smaller screens, the modal should take up the full width
  @media screen and (max-width: ${({theme}) => theme.screenBreakpoint.md.px}) {
    width: 100%;
  }
`;

export const ModalDialogTitle = styled(DialogTitle)`
  font-size: ${({theme}) => theme.typography.fontSize.lg};
  padding-bottom: 10px;
`;

export const CustomDialogActions = styled(DialogActions)`
  padding-top: 0;
  flex-direction: column;
  align-items: stretch;
  gap: ${({theme}) => theme.gap.desktop.lg};

  // Mobile
  @media screen and (max-width: ${({theme}) => theme.screenBreakpoint.md.px}) {
    gap: ${({theme}) => theme.gap.desktop.md};
  }
`;

export const CustomDialogContent = styled(DialogContent)`
  gap: ${({theme}) => theme.gap.desktop.lg};
`;
